export const levels = {
  0:  { neededXp: 0,     level: 0  },
  1:  { neededXp: 50,    level: 1  },
  2:  { neededXp: 100,   level: 2  },
  3:  { neededXp: 150,   level: 3  },
  4:  { neededXp: 200,   level: 4  },
  5:  { neededXp: 250,   level: 5  },
  6:  { neededXp: 300,   level: 6  },
  7:  { neededXp: 350,   level: 7  },
  8:  { neededXp: 400,   level: 8  },
  9:  { neededXp: 425,   level: 9  },
  10: { neededXp: 450,   level: 10 }, // Silver
  11: { neededXp: 600,   level: 11 },
  12: { neededXp: 750,   level: 12 },
  13: { neededXp: 900,   level: 13 },
  14: { neededXp: 1050,  level: 14 },
  15: { neededXp: 1150,  level: 15 },
  16: { neededXp: 1250,  level: 16 },
  17: { neededXp: 1350,  level: 17 },
  18: { neededXp: 1400,  level: 18 },
  19: { neededXp: 1450,  level: 19 },
  20: { neededXp: 1500,  level: 20 }, // Gold
  21: { neededXp: 1600,  level: 21 },
  22: { neededXp: 1700,  level: 22 },
  23: { neededXp: 1850,  level: 23 },
  24: { neededXp: 2000,  level: 24 },
  25: { neededXp: 2100,  level: 25 },
  26: { neededXp: 2200,  level: 26 },
  27: { neededXp: 2300,  level: 27 },
  28: { neededXp: 2400,  level: 28 },
  29: { neededXp: 2450,  level: 29 },
  30: { neededXp: 2500,  level: 30 }, // Platinum
  31: { neededXp: 3000,  level: 31 },
  32: { neededXp: 3500,  level: 32 },
  33: { neededXp: 4000,  level: 33 },
  34: { neededXp: 4500,  level: 34 },
  35: { neededXp: 5500,  level: 35 },
  36: { neededXp: 6500,  level: 36 },
  37: { neededXp: 7500,  level: 37 },
  38: { neededXp: 8500,  level: 38 },
  39: { neededXp: 9500,  level: 39 },
  40: { neededXp: 10000, level: 40 }, // Diamond
  41: { neededXp: 11000, level: 41 },
  42: { neededXp: 12000, level: 42 },
  43: { neededXp: 13000, level: 43 },
  44: { neededXp: 14000, level: 44 },
  45: { neededXp: 15000, level: 45 },
  46: { neededXp: 16000, level: 46 },
  47: { neededXp: 17000, level: 47 },
  48: { neededXp: 18000, level: 48 },
  49: { neededXp: 19000, level: 49 },
  50: { neededXp: 20000, level: 50 }  // Master
};

export const tiers = {
  bronze: {
    neededXp: 0,
    name: 'Bronze',
    color: '#CD7F32'
  },
  silver: {
    neededXp: 450,
    name: 'Silver',
    color: '#C0C0C0'
  },
  gold: {
    neededXp: 100000,
    name: 'Gold',
    color: '#FFD700'
  },
  platinum: {
    neededXp: 200000,
    name: 'Platinum',
    color: '#E5E4E2'
  },
  diamond: {
    neededXp: 300000,
    name: 'Diamond',
    color: '#B9F2FF'
  },
  master: {
    neededXp: 400000,
    name: 'Master',
    color: '#FF6B6B'
  }
};

// Helper functions
export const getCurrentLevel = (totalXP) => {
  let currentLevel = 0;
  
  for (let level = 0; level <= 50; level++) {
    if (totalXP >= levels[level].neededXp) {
      currentLevel = level;
    } else {
      break;
    }
  }
  
  return currentLevel;
};

export const getXPForNextLevel = (totalXP) => {
  const currentLevel = getCurrentLevel(totalXP);
  const nextLevel = currentLevel + 1;
  
  if (nextLevel > 50) {
    return null; // Max level reached
  }
  
  return levels[nextLevel].neededXp;
};

export const getXPProgress = (totalXP) => {
  const currentLevel = getCurrentLevel(totalXP);
  const currentLevelXP = levels[currentLevel].neededXp;
  const nextLevelXP = getXPForNextLevel(totalXP);
  
  if (!nextLevelXP) {
    return { current: 0, needed: 0, percentage: 100 }; // Max level
  }
  
  const currentProgress = totalXP - currentLevelXP;
  const neededProgress = nextLevelXP - currentLevelXP;
  const percentage = Math.min((currentProgress / neededProgress) * 100, 100);
  
  return {
    current: currentProgress,
    needed: neededProgress,
    percentage: Math.round(percentage)
  };
};

export const getCurrentTier = (totalXP) => {
  let currentTier = 'bronze';
  
  for (const [tierName, tierData] of Object.entries(tiers)) {
    if (totalXP >= tierData.neededXp) {
      currentTier = tierName;
    }
  }
  
  return currentTier;
};

export const getXPForNextTier = (totalXP) => {
  const currentTier = getCurrentTier(totalXP);
  const tierNames = Object.keys(tiers);
  const currentTierIndex = tierNames.indexOf(currentTier);
  
  // If already at the highest tier (Master), return null
  if (currentTierIndex === tierNames.length - 1) {
    return null;
  }
  
  const nextTierName = tierNames[currentTierIndex + 1];
  const nextTierXP = tiers[nextTierName].neededXp;
  
  return {
    tierName: nextTierName,
    neededXP: nextTierXP,
    currentProgress: totalXP,
    remainingXP: nextTierXP - totalXP
  };
}; 